// import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
// import { BrowserRouter as Router, Link, useLocation, useNavigate  } from "react-router-dom";

// // reactstrap components
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   CardTitle,
//   Row,
//   Col,
//   Button,
//   Modal, ModalBody, ModalFooter
// } from "reactstrap";

// import ChromeCheck from "views/ChromeCheck.jsx";
// import tenMinutes from "components/10-mins.jpg";


// import ReadAloud from "components/Question/Mocks/Speaking/ReadAloud.jsx";
// import RepeatSentece from "components/Question/Mocks/Speaking/RepeatSentece.jsx";
// import DescribeImage from "components/Question/Mocks/Speaking/DescribeImage.jsx";
// import RetellLec from "components/Question/Mocks/Speaking/RetellLec.jsx";
// import ShortQue from "components/Question/Mocks/Speaking/ShortQue.jsx";

// import Summary from "components/Question/Mocks/Writting/Summary.jsx";
// import Essay from "components/Question/Mocks/Writting/Essay.jsx";

// import SingleAnswer from "components/Question/Mocks/Reading/SingleAnswer.jsx";
// import MultipleAnswer from "components/Question/Mocks/Reading/MultipleAnswer.jsx";
// import Reorder from "components/Question/Mocks/Reading/Reorder1.jsx";
// import ReadingBlank from "components/Question/Mocks/Reading/ReadingBlank.jsx";
// import WrittingBlank from "components/Question/Mocks/Reading/WrittingBlank.jsx";

// import Summer from "components/Question/Mocks/Listening/Summer.jsx";
// import McqSingle from "components/Question/Mocks/Listening/McqSingle.jsx";
// import McqMulti from "components/Question/Mocks/Listening/McqMulti.jsx";
// import ListeningBlank from "components/Question/Mocks/Listening/ListeningBlank.jsx";
// import MissingWord from "components/Question/Mocks/Listening/MissingWord.jsx";
// import CorrectSummary from "components/Question/Mocks/Listening/CorrectSummary.jsx";
// import Dictation from "components/Question/Mocks/Listening/Dictation.jsx";
// import Highlight from "components/Question/Mocks/Listening/Highlight.jsx";

// import ResourceCheck from "./ResourceCheck.jsx";
// import Skeleton from 'react-loading-skeleton'
// import 'react-loading-skeleton/dist/skeleton.css'
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";

// // core components
// import { NavLink } from "react-router-dom";
// import API from "api.js";
// import { store } from 'store/index';
// import { setAlert } from 'action/index.js';



// function Test() {
// //  const history = useHistory();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [state , setState] = useState( {
//   questionData: [],
//   currentQuestion: 0,
//   isRecording: false,
//   blobURL: '',
//   isBlocked: false,
//   type: '',
//   result: {
//     strategy: 1
//   },
//   finalResult: [],
//   lastFlag: true,
//   resultId: false,
//   secondCount: 0,
//   submitProcess: false,
//   saveProcess: false,
//   dashboardFlag: false,
//   resourceTested: false,
//   mockCat: false,
//   mockTime: 20,
//   title: '',
//   modal: false,
//   pending: 0,
//   msg: '',
//   qTime: 0,
//   nextType: 0,
//   stopRecording: false,
//   soundStat: true,
//   soundModal: false,
//   soundArr: [2, 4, 5, 13, 14, 15, 16, 17, 18, 19, 20],
//   q_count: 0,
//   timeOutFlag: false,
//   listeningArr: [],
//   speakingArr: [],
//   readingArr: [],
//   writtingArr: [],
//   fullArr: [],
//   testIndex: 0,
//   timeArr: [],
//   typeArr: [],
//   skip: 0,
//   stopTimer: true,
//   changePhase: false,
//   curr_q: 0,
//   waitFlag: true,
//   all_ok: true,
//   ids: [],
//   submittedId: [],
//   complete: 0,
//   mockBreak: 0,
//   curr_section: 1,
//   save_and_exit: false,
//   pending_ques_number_modify: false,
//   mock_already_complete: false,
//   check_ok: false,
//   redirect_to_pending: false,
//   redirect_to_begin: false,
//   missing_data: {},
//   failed: [],
//   internet: true,
//   lastQuestions: [],
//   loading: false
// })

// const isSetMockTimePendingRef = useRef(false);
// const intervalRef = useRef();

// useEffect(() => {
//   console.log("This is the functional Component of the  Full test")
//     // Priority: Add class to body
//     document.body.classList.add("leftSidebarClosed");

//     // If no location.state, redirect to mock list
//     if (!location.state) {
//       document.body.classList.toggle("withoutBar");
//       document.body.classList.toggle("sidebar-test-close");
//       navigate('/admin/mock', { replace: true })
//       return;
//     }

//     // Prevent page unload/reload
//     const onUnloadListener = (e) => {
//       e.preventDefault();
//       e.returnValue = "";
//       return "";
//     };
//     window.addEventListener('beforeunload', onUnloadListener);

//     // Detect Chrome
//     const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
//     updateState({ all_ok: isChrome });

//     // Hide sidebar & disable right-click
//     document.body.classList.toggle("withoutBar");
//     const preventContextMenu = (e) => e.preventDefault();
//     document.addEventListener('contextmenu', preventContextMenu);

//     const { id, pending } = location.state;

//     // Fetch mock detail
//     API({
//       method: 'GET',
//       url: `web/question/detail/${id}/${pending}`
//     })
//     .then(response => {
//       const data = response.data;

//       if ('code' in data && data.code === 'F') {
//         navigate("/admin/unauthorized");
//         return;
//       }

//       console.log('data: ', data);

//       let to_pending = false;
//       let to_begin = false;
//       if (parseInt(pending) === 0 && data.resume === true) {
//         to_pending = true;
//       } else if (parseInt(pending) === 1 && data.resume === false) {
//         to_begin = true;
//       }

//       let speak = [];
//       let write = [];
//       let read = [];
//       let listen = [];
//       let fullArr = [];
//       let timeArr = [];
//       let typeArr = [];

//       const { mock, q_count, curr_q, skip } = data;
//       const mockBreak = mock.break;

      
//       mock.question.forEach(v => {
//         if ([1,2,3,4,5,6,7].includes(v.subcategory_id)) {
//           speak.push(v);
//         } else if ([8,9,10,11,12].includes(v.subcategory_id)) {
//           read.push(v);
//         } else if ([13,14,15,16,17,18,19,20].includes(v.subcategory_id)) {
//           listen.push(v);
//         }
//       });

    
//       if (true) { // Speaking section always included
//         fullArr.push(speak);
//         timeArr.push(mock.speaking_time + mock.writting_time);
//         typeArr.push(1);
//       }

//       if (true) { // Reading
//         fullArr.push(read);
//         timeArr.push(mock.reading_time);
//         typeArr.push(2);
//       }

//       if (true) { // Listening
//         fullArr.push(listen);
//         timeArr.push(mock.listening_time);
//         typeArr.push(3);
//       }

//       const lastQues = [];
//       if (speak.length > 0) {
//         const { id, skip } = speak[speak.length - 1];
//         lastQues.push({ id, skip });
//       }
//       if (read.length > 0) {
//         const { id, skip } = read[read.length - 1];
//         lastQues.push({ id, skip });
//       }
//       if (listen.length > 0) {
//         const { id, skip } = listen[listen.length - 1];
//         lastQues.push({ id, skip });
//       }
//       console.log(lastQues);

    
//       let seq = parseInt(pending) === 0 ? 1 : (data.q_count + 1);
//       fullArr.forEach(section => {
//         section.forEach(item => {
//           item.question_number = seq++;
//         });
//       });

    
//       let mock_state = parseInt(pending);
//       let waitFlagValue = true;

//       if (mock_state === 0 && mockBreak === 1) {
//         waitFlagValue = false;
//       } else if (mock_state === 1 && skip < 2) {
//         if (mockBreak === 1) waitFlagValue = false;
//       } else if (mock_state === 1 && skip >= 2) {
//         waitFlagValue = false;
//       }

//       let curr_section = mock_state === 1 ? skip + 1 : 1;

     
//       updateState({
//         mock_already_complete: data.complete === 1,
//         check_ok: true,
//         redirect_to_pending: to_pending,
//         redirect_to_begin: to_begin,
//         ids: fullArr[data.skip],
//         typeArr,
//         timeArr,
//         fullArr,
//         listeningArr: listen,
//         speakingArr: speak,
//         writtingArr: write,
//         readingArr: read,
//         title: mock.title,
//         mockCat: mock.category,
//         skip: data.skip,
//         testIndex: data.skip,
//         questionData: fullArr[data.skip],
//         type: fullArr[data.skip][0]?.subcategory_id || null,
//         mockBreak,
//         waitFlag: waitFlagValue,
//         curr_section
//       });

//       // After setting question data, set timer and sound
//       setTimeout(() => {
//         let soundStat = true;
//         if (state.soundArr.includes(fullArr[data.skip][0]?.subcategory_id)) {
//           soundStat = false;
//         }

//         let timeVar = timeArr[data.skip];
//         if (parseInt(pending) === 1) {
//           timeVar = data.time;
//         }

//         // Start timer
//         const intervalId = setInterval(() => {
//           setState(prev => {
//             if (prev.secondCount <= 0) {
//               clearInterval(intervalRef.current);
//               return prev;
//             }
//             return { ...prev, secondCount: prev.secondCount - 1 };
//           });
//         }, 1000);


//         intervalRef.current = intervalId;

//         updateState({
//           q_count,
//           curr_q,
//           soundStat,
//           intervalId,
//           secondCount: parseInt(parseFloat(timeVar) * 60),
//           mockTime: parseInt(parseFloat(timeVar) * 60),
//           pending_ques_number_modify: parseInt(pending) === 1
//         });
//       }, 0);

//     })
//     .catch(err => {
//       console.error("API Error:", err);
//     });


//     navigator.mediaDevices.getUserMedia({ audio: true })
//       .then(() => updateState({ isBlocked: false }))
//       .catch(() => updateState({ isBlocked: true }));

 
//     return () => {
//       window.removeEventListener('beforeunload', onUnloadListener);
//       document.removeEventListener('contextmenu', preventContextMenu);
//       document.body.classList.toggle("withoutBar");
//       document.body.classList.remove("leftSidebarClosed");

//       if (intervalRef.current) {
//         clearInterval(intervalRef.current);
//       }
//     };
//   }, [location.state, navigate]);


// const updateState = (updates) => {
//     setState(prevState => ({
//       ...prevState,
//       ...(typeof updates === 'function' ? updates(prevState) : updates)
//     }));
//   };

// const nextSection = useCallback(() => {
//     let { curr_section, fullArr, testIndex, timeArr } = state;
//   	let inc_next_section = curr_section + 1;
//   setState(prev => {
//     const inc_next_section = prev.curr_section + 1;
//     return {
//       ...prev,
//       ids: prev.fullArr[prev.testIndex],
//       curr_q: 0,
//       currentQuestion: 0,
//       changePhase: false,
//       questionData: prev.fullArr[prev.testIndex],
//       type: prev.fullArr[prev.testIndex][0].subcategory_id,
//       curr_section: inc_next_section,
//       pending_ques_number_modify: false
//     };
//   });
// }, []);


// const exitSection = useCallback(() => {
//   const { fullArr, testIndex, timeArr } = state;
  
//   console.log('-------------------------------exitSection-------------------------------');
//   console.log('type', fullArr[testIndex][0].subcategory_id);
//   console.log('timeArr', timeArr);
//   console.log('testIndex', testIndex);
//   console.log('time', timeArr[testIndex]);
  
//   const bodyFormData = new FormData();
//   bodyFormData.append('mock_id', location.state.id);
//   bodyFormData.append('time', timeArr[testIndex]);
//   bodyFormData.append('pending', 1);
//   bodyFormData.append('complete', 0);

//   API({
//     method: 'POST',
//     url: 'exit/mocksection',
//     data: bodyFormData
//   }).then(() => {
//     clearInterval(state.intervalId);
//     document.getElementById("start_next_section").disabled = true;
//     document.getElementById("exit_section").disabled = true;
//     window.location.href = "/admin/dashboard";
//   }).catch(() => {});
// }, [state, location.state.id]);


// const submitResponse = useCallback((data, f = false) => {
//   if (f) return;
  
//   const obj = {
//     data: data.data,
//     text_answer: data.answer,
//     length: data.length,
//     correct: data.correct
//   };
  
//   setState(prev => ({ ...prev, result: obj }));
// }, []);


// const resultStatus = useCallback(() => {
//   setState(prev => ({ ...prev, is_result: true }));
// }, []);


// const setMockTime = useCallback(async () => {
//   if (isSetMockTimePendingRef.current) return;
  
//   const { timeArr, testIndex, ids, mockBreak } = state;
//   const bodyFormData = new FormData();
//   let time = 0;
  
//   bodyFormData.append('mock_id', location.state.id);

//   if (timeArr.length === (testIndex + 1)) {
//     bodyFormData.append('time', 0);
//   } else {
//     bodyFormData.append('time', timeArr[testIndex + 1]);
//     time = (parseInt(testIndex) === 1 && mockBreak === 0) 
//       ? 10 
//       : timeArr[testIndex + 1];
//   }

//   ids.forEach((v, k) => {
//     if (k !== 0) {
//       bodyFormData.append('id[]', `${v.id}-${v.question_number}`);
//     }
//   });

//   console.log(ids, testIndex);
//   bodyFormData.append('skip', testIndex + 1);

//   try {
//     isSetMockTimePendingRef.current = true;
//     await API({
//       method: 'Post',
//       url: 'set/mockTime',
//       data: bodyFormData
//     });
//     setState(prev => ({ ...prev, secondCount: time * 60 }));
//   } catch (error) {
//     console.error('setMockTime error:', error);
//   } finally {
//     isSetMockTimePendingRef.current = false;
//   }
// }, [state, location.state.id]);

// const skipWait = useCallback(() => {
//   setState(prev => ({
//     ...prev,
//     waitFlag: false,
//     secondCount: parseFloat(prev.timeArr[prev.testIndex]) * 60,
//     mockTime: parseFloat(prev.timeArr[prev.testIndex]) * 60
//   }));
// }, []);

// const nextButton = useCallback((e, p) => {
//   console.log('p:', p);
//   const { soundStat, typeArr, testIndex } = state;
//   let pending = 0;
//   let msg = "";
//   let complete = 0;
//   let save_and_exit = false;

//   if (p === 0 && !soundStat) {
//     setState(prev => ({ ...prev, soundModal: true }));
//     return;
//   } else if (p === 0 && soundStat) {
//     pending = 0;
//     msg = "Do you want to go to next Question?";
//   } else if (p === 1) {
//     pending = 0;
//     msg = "Do you want to submit this section?";
//     complete = typeArr[testIndex] === 3 ? 1 : 0;
//   } else if (p === 2) {
//     pending = 1;
//     msg = "Do you want to save and exit mock test?";
//     save_and_exit = true;
//   } else if (p === 3) {
//     pending = typeArr[testIndex] === 3 ? 0 : 1;
//     complete = pending === 1 ? 0 : 1;
//     msg = "Timeout";
//   }

//   setState(prev => ({
//     ...prev,
//     pending,
//     msg,
//     nextType: p,
//     complete,
//     save_and_exit,
//     modal: true
//   }));
// }, [state]);

// const timer = useCallback(async () => {
//   const connection = store.getState().intStatus ?? true;
  
//   if (connection) {
//     setState(prev => {
//       if (!prev.internet) {
//         return { ...prev, internet: true };
//       }
//       return prev;
//     });

//     const { secondCount, typeArr, testIndex, waitFlag, stopTimer, qTime, intervalId } = state;

//     if (secondCount <= 1) {
//       if (typeArr[testIndex] === 3 && waitFlag) {
//         skipWait();
//         return true;
//       }

//       nextButton('d', 3);
//       console.log('------- timeout');
//       setMockTime();

//       if (testIndex === 2) {
//         clearInterval(intervalId);
//       }
//     }

//     if (stopTimer) {
//       setState(prev => ({
//         ...prev,
//         secondCount: prev.secondCount - 1,
//         qTime: prev.qTime + 1
//       }));
//     }
//   } else {
//     setState(prev => {
//       if (prev.internet) {
//         return { ...prev, internet: false };
//       }
//       return prev;
//     });
//   }
// }, [state, skipWait, nextButton, setMockTime]);




// const toggleYes = useCallback(() => {
//   setState(prev => ({
//     ...prev,
//     stopRecording: true,
//     modal: false
//   }));
// }, []);


// const loadNextQuestionProcess = useCallback(() => {
//   setState(prev => ({ ...prev, loading: true }));
//   setTimeout(() => {
//     setState(prev => ({ ...prev, loading: false }));
//   }, 500);
// }, []);

// const finalObjectCreation = useCallback((obj1 = false) => {
//   const { questionData, currentQuestion, result } = state;
//   const qdata = questionData[currentQuestion];
//   const response = true;

//   const baseObj = {
//     type: qdata.subcategory_id,
//     id: qdata.id,
//     response,
//     answer: qdata.question,
//     script: qdata.audio_script,
//     q_ans: qdata.answer
//   };

//   return obj1 ? { ...obj1, ...baseObj } : { ...result, ...baseObj };
// }, [state]);

// const finalSubmit = useCallback((obj1, type) => {
//   const { questionData, currentQuestion, secondCount, qTime, complete, timeArr, testIndex, pending, curr_q, ids, save_and_exit } = state;
//   const curr = questionData[currentQuestion];
//   const obj = [obj1];
//   let time = secondCount;
//   let tFlag = false;

//   const bodyFormData = new FormData();
  
//   if (location.state.pending === 1) {
//     bodyFormData.append('result_id', location.state.id);
//   }
  
//   bodyFormData.append('q_count', questionData.length);
//   bodyFormData.append('mock_id', location.state.id);
//   bodyFormData.append('q_time', qTime);
//   bodyFormData.append('complete', complete);
//   bodyFormData.append('question_number', curr.question_number);

//   if (secondCount <= 0) {
//     time = timeArr.length === testIndex + 1 ? 0 : timeArr[testIndex + 1] * 60;
//   }

//   bodyFormData.append('pending', pending);
  
//   if (type == 1) {
//     time = timeArr[testIndex + 1] * 60;
//   }

//   if (type === 3) {
//     bodyFormData.append('curr_q', 0);
//   } else {
//     const curr_q_value = questionData.length === currentQuestion + 1
//       ? (pending === 1 ? currentQuestion + curr_q : 0)
//       : (pending === 1 ? currentQuestion + curr_q : currentQuestion + curr_q + 1);
//     bodyFormData.append('curr_q', curr_q_value);
//   }

//   obj.forEach(v => {
//     if ([6, 7, 13].includes(v.type)) {
//       tFlag = true;
//       if (parseInt(type) !== 1) {
//         time = time < 1 ? 1 : (!save_and_exit ? (secondCount - v.second) : secondCount);
//       }
//     } else {
//       time = parseInt(type) === 1 ? time : secondCount;
//     }
    
//     time = (parseInt(type) === 1 && testIndex === 2) ? 0 : time;
//     bodyFormData.append('time', time);

//     if (!save_and_exit) {
//       if (curr.skip) {
//         bodyFormData.append('skip', curr.skip);
//       }
//       bodyFormData.append('response[]', v.response);
//       bodyFormData.append('device', 'website');

//       // Speaking questions (1-5)
//       if ([1, 2, 3, 4, 5].includes(v.type)) {
//         bodyFormData.append('text[]', v.answer);
//         bodyFormData.append('selected[]', v.text_answer);
//         bodyFormData.append('text_answer[]', v.text_answer);
//         bodyFormData.append('answer[]', v.ans);
//         bodyFormData.append('lang[]', v.lang);
//         bodyFormData.append('html[]', v.html);
//         bodyFormData.append('audio_text[]', v.audio_text);
//         bodyFormData.append('q_ans[]', v.q_ans);
//         bodyFormData.append('length[]', v.length);
//         bodyFormData.append('ans[]', v.q_ans);
//         bodyFormData.append('duration[]', v.duration);
        
//         const fileBlob = v.data === "" || v.data === undefined 
//           ? new Blob(['hello worlppppppppppppd']) 
//           : v.data;
//         bodyFormData.append('file[]', fileBlob);

//         if (parseInt(v.type) === 1) {
//           bodyFormData.set('strategy', v.strategy);
//         }

//         bodyFormData.append('type[]', v.type);
//         bodyFormData.append('correct[]', v.correct);
//         bodyFormData.append('script[]', v.script);
//         bodyFormData.append('id[]', v.id);
//       } 
//       // Writing questions (6-7)
//       else if ([6, 7].includes(v.type)) {
//         bodyFormData.append('text[]', v.answer);
//         bodyFormData.append('text_answer[]', v.text_answer);
//         bodyFormData.append('selected[]', v.text_answer);
//         bodyFormData.append('type[]', v.type);
//         bodyFormData.append('audio_text[]', v.audio_text);
//         bodyFormData.append('answer[]', v.q_ans);
//         bodyFormData.append('script[]', v.script);
//         bodyFormData.append('ans[]', v.q_ans);
//         bodyFormData.append('lang[]', v.lang);
//         bodyFormData.append('html[]', v.html);
//         bodyFormData.append('file[]', new Blob(['hello worlppppppppppppd']));
//         bodyFormData.append('correct[]', v.correct);
//         bodyFormData.append('length[]', v.length);
//         bodyFormData.append('id[]', v.id);
//         bodyFormData.append('q_ans[]', v.q_ans);
//         bodyFormData.append('duration[]', v.duration);
//       } 
//       // Reading questions (8-12)
//       else if ([8, 9, 10, 11, 12].includes(v.type)) {
//         bodyFormData.append('text[]', v.answer);
//         bodyFormData.append('selected[]', v.text_answer);
//         bodyFormData.append('type[]', v.type);
//         bodyFormData.append('lang[]', v.lang);
//         bodyFormData.append('text_answer[]', v.text_answer);
//         bodyFormData.append('answer[]', v.correct);
//         bodyFormData.append('script[]', v.script);
//         bodyFormData.append('correct[]', v.correct);
//         bodyFormData.append('ans[]', v.q_ans);
//         bodyFormData.append('length[]', v.length);
//         bodyFormData.append('id[]', v.id);
//         bodyFormData.append('audio_text[]', v.audio_text);
//         bodyFormData.append('html[]', v.html);
//         bodyFormData.append('file[]', new Blob(['hello worlppppppppppppd']));
//         bodyFormData.append('q_ans[]', v.q_ans);
//         bodyFormData.append('duration[]', v.duration);
//       } 
//       // Listening questions (13-20)
//       else if ([13, 14, 15, 16, 17, 18, 19, 20].includes(v.type)) {
//         bodyFormData.append('text[]', v.answer);
//         bodyFormData.append('selected[]', v.text_answer);
//         bodyFormData.append('type[]', v.type);
//         bodyFormData.append('answer[]', v.correct);
//         bodyFormData.append('lang[]', v.lang);
//         bodyFormData.append('script[]', v.script);
//         bodyFormData.append('ans[]', v.q_ans);
//         bodyFormData.append('correct[]', v.correct);
//         bodyFormData.append('length[]', v.length);
//         bodyFormData.append('html[]', v.html);
//         bodyFormData.append('audio_text[]', v.audio_text);
//         bodyFormData.append('text_answer[]', v.text_answer);
//         bodyFormData.append('id[]', v.id);
//         bodyFormData.append('file[]', new Blob(['hello worlppppppppppppd']));
//         bodyFormData.append('q_ans[]', v.q_ans);
//         bodyFormData.append('duration[]', v.duration);
//       }
//     }
//   });

//   API({
//     method: 'POST',
//     url: 'submit/mock',
//     data: bodyFormData
//   }).then(data => {
//     const { typeArr, testIndex } = state;
//     const filteredAry = ids.filter(e => e.id !== obj[0].id);
    
//     if (tFlag) {
//       if (typeArr[testIndex] === 2) {
//         setState(prev => ({
//           ...prev,
//           qTime: 0,
//           ids: filteredAry
//         }));
//       } else {
//         setState(prev => ({
//           ...prev,
//           secondCount: time,
//           qTime: 0,
//           ids: filteredAry
//         }));
//       }
//     } else {
//       setState(prev => ({
//         ...prev,
//         qTime: 0,
//         ids: filteredAry
//       }));
//     }

//     if (!(data.status === 200 && data.data.status === 200)) {
//       setState(prev => ({ ...prev, submitProcess: false }));
//       store.dispatch(setAlert({
//         flag: true,
//         type: 2,
//         message: "Something went wrong."
//       }));
//     }
//   }).catch(() => {
//     setState(prev => ({
//       ...prev,
//       failed: [...prev.failed, bodyFormData]
//     }));
//   });
// }, [state, location.state]);

// const submitFailed = useCallback(() => {
//   if (state.failed.length === 0) return;

//   const formData = new FormData();
  
//   state.failed.forEach((value, index) => {
//     value.forEach((val, key) => {
//       if (key === 'file[]') {
//         formData.append('files[]', val);
//       } else {
//         formData.append(`data[${index}][${key}]`, val);
//       }
//     });
//   });

//   setTimeout(() => {
//     API({
//       method: "POST",
//       url: "submitFailed/mock",
//       data: formData,
//     })
//       .then(() => {
//         setState(prev => ({ ...prev, failed: [] }));
//       })
//       .catch(() => {});
//   }, 2000);
// }, [state.failed]);

// const nextQuestion = useCallback(async (obj) => {
//   loadNextQuestionProcess();

//   const obj2 = {
//     data: obj.data,
//     text_answer: obj.answer,
//     length: obj.length,
//     correct: obj.correct,
//     second: obj.time,
//     lang: obj.lang,
//     html: obj.html,
//     audio_text: obj.audio_text,
//     duration: obj.duration,
//     strategy: state.result.strategy,
//   };

//   const { nextType, fullArr, testIndex, timeArr, soundArr, questionData, currentQuestion, save_and_exit } = state;
//   const obj1 = await finalObjectCreation(obj2);

//   finalSubmit(obj1, nextType);

//   if (nextType === 1) {
//     submitFailed();
//     if (fullArr.length >= testIndex + 2) {
//       setState(prev => {
//         const newState = {
//           ...prev,
//           stopRecording: false,
//           modal: false,
//           stopTimer: true,
//           testIndex: testIndex + 1,
//           changePhase: true,
//           nextType: 3,
//           secondCount: parseFloat(timeArr[testIndex + 1]) * 60,
//           mockTime: parseFloat(timeArr[testIndex + 1]) * 60
//         };

//         if (prev.typeArr[testIndex + 1] === 3 && prev.waitFlag) {
//           newState.secondCount = 600;
//           newState.mockTime = 600;
//         }

//         return newState;
//       });
//     } else {
//       setState(prev => ({
//         ...prev,
//         stopRecording: false,
//         modal: false,
//         dashboardFlag: true
//       }));
//       store.dispatch(setAlert({
//         flag: true,
//         type: 1,
//         message: `Mock ${save_and_exit ? 'saved' : 'submitted'} successfully`
//       }));
//     }
//   } else if (nextType === 3) {
//     submitFailed();
//     if (fullArr.length >= testIndex + 2) {
//       setState(prev => ({
//         ...prev,
//         stopRecording: false,
//         modal: false,
//         stopTimer: true,
//         testIndex: testIndex + 1,
//         changePhase: true,
//         nextType: 3
//       }));
//     } else {
//       setState(prev => ({
//         ...prev,
//         stopRecording: false,
//         modal: false,
//         dashboardFlag: true
//       }));
//       store.dispatch(setAlert({
//         flag: true,
//         type: 1,
//         message: `Mock ${save_and_exit ? 'saved' : 'submitted'} successfully`
//       }));
//     }
//   } else if (nextType === 2) {
//     submitFailed();
//     setState(prev => ({
//       ...prev,
//       stopRecording: false,
//       modal: false,
//       dashboardFlag: true
//     }));
//     clearInterval(state.intervalId);
//     store.dispatch(setAlert({
//       flag: true,
//       type: 1,
//       message: `Mock ${save_and_exit ? 'saved' : 'submitted'} successfully`
//     }));
//   } else if (nextType === 0) {
//     const soundStat = !soundArr.includes(questionData[currentQuestion + 1].subcategory_id);
//     const currentStrategy = state.result.strategy;
    
//     setState(prev => ({
//       ...prev,
//       soundStat,
//       stopRecording: false,
//       result: { strategy: currentStrategy },
//       currentQuestion: currentQuestion + 1,
//       type: questionData[currentQuestion + 1].subcategory_id,
//       modal: false
//     }));
//   }
// }, [state, loadNextQuestionProcess, finalObjectCreation, finalSubmit, submitFailed]);


// const toggle = useCallback(() => {
//   setState(prev => ({ ...prev, modal: !prev.modal }));
// }, []);


// const soundChecked = useCallback(() => {
//   setState(prev => ({ ...prev, soundStat: true }));
// }, []);


// const showTest = useCallback(() => {
//   const intervalId = setInterval(timer, 1000);
//   setState(prev => ({
//     ...prev,
//     resourceTested: true,
//     secondCount: prev.mockTime,
//     intervalId
//   }));
// }, [timer]);


// const closeSoundModal = useCallback(() => {
//   setState(prev => ({ ...prev, soundModal: false }));
// }, []);


// const getTypeName = useCallback(() => {
//   const { typeArr, testIndex } = state;
//   const typeMap = {
//     1: "Speaking & Writing",
//     2: "Reading Test",
//     3: "Listening Test"
//   };
//   return typeMap[typeArr[testIndex]] || "d";
// }, [state]);

// const closeTimeoutModal = useCallback(() => {
//   setState(prev => ({ ...prev, timeOutFlag: false }));
// }, []);





// const setStrategy = useCallback((st) => {
//   setState(prev => ({
//     ...prev,
//     result: { ...prev.result, strategy: st }
//   }));
// }, []);


// const redirectToMock = useCallback((id, pending) => {
//   navigate('/admin/fulltest', { state: { id, pending } });
//   window.location.reload();
// }, [navigate]);
  
// const getQuestionComponent = useCallback(() => {
//   if (state.questionData.length === 0) return null;

//   const queProps = {
//     submit: submitResponse,
//     showResult: resultStatus,
//     data: state.questionData[state.currentQuestion],
//     resultMode: false,
//     testMode: true,
//     soundChecked: soundChecked,
//     stopRecording: state.stopRecording,
//     nextQuestion: nextQuestion,
//     strategy: state.result.strategy,
//     setStrategy: setStrategy
//   };

//   const questionComponents = {
//     1: { 
//       component: <ReadAloud {...queProps} key={state.currentQuestion} />,
//       title: "Look at the text below. In the 35 seconds, you must read this text aloud as naturally and clearly as possible. You have 35 seconds to read aloud."
//     },
//     2: { 
//       component: <RepeatSentece {...queProps} key={state.currentQuestion} />,
//       title: "You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once."
//     },
//     3: { 
//       component: <DescribeImage {...queProps} key={state.currentQuestion} />,
//       title: "Look at the Image below. In 25 seconds,please speak into the microphone and describe in detail what the graph showing. You will have 40 seconds to give your response."
//     },
//     4: { 
//       component: <RetellLec {...queProps} key={state.currentQuestion} />,
//       title: "You will hear a lecture. After listening to the lecture, in 10 seconds, please speak into the microphone and retell what you have just heard from the lecture in your own words. You will have 40 seconds to give your response."
//     },
//     5: { 
//       component: <ShortQue {...queProps} />,
//       title: "You will hear a question. Please give a simple and short answer. Often just one or a few words is enough."
//     },
//     6: { 
//       component: <Summary {...queProps} />,
//       title: "Read the passage and summarize it using one sentence. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. your response will be judge on the quality of your writing and on how well your response presents the key points in the passage."
//     },
//     7: { 
//       component: <Essay {...queProps} />,
//       title: "You will have 20 minutes to plan, write and revise an essay about the topic below. your response will be judged on how well you develop a position, oraganize your ideas, present supporting details, and control the elements of standard written English. You should write 200-300 words."
//     },
//     8: { 
//       component: <SingleAnswer {...queProps} />,
//       title: "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct."
//     },
//     9: { 
//       component: <MultipleAnswer {...queProps} />,
//       title: "Read the text and answer the question by selecting all the correct responses. More than one response is correct."
//     },
//     10: { 
//       component: <Reorder {...queProps} />,
//       title: "The textbox in the left panel have been placed in a random order. Restore the original order by dragging the text boxes from the left panel to the right panel."
//     },
//     11: { 
//       component: <ReadingBlank {...queProps} />,
//       title: "In the text below some words are missing. Drag words from the text box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text."
//     },
//     12: { 
//       component: <WrittingBlank {...queProps} />,
//       title: "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank."
//     },
//     13: { 
//       component: <Summer {...queProps} />,
//       title: "You will hear a short lecture. Write a summary for a fellow student who was not present at the lecture. You should wirte 50-70 words. You have 10 minutes to finish the task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the lecture."
//     },
//     14: { 
//       component: <McqSingle {...queProps} />,
//       title: "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct."
//     },
//     15: { 
//       component: <McqMulti {...queProps} />,
//       title: "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response."
//     },
//     16: { 
//       component: <ListeningBlank {...queProps} />,
//       title: "You will hear a recording. Type the missing words in each blank."
//     },
//     17: { 
//       component: <CorrectSummary {...queProps} />,
//       title: "You will hear a recording. Click on the paragraph that best relates to the recording."
//     },
//     18: { 
//       component: <MissingWord {...queProps} />,
//       title: `You will hear a recording about ${state.questionData[state.currentQuestion]?.q_title || ''}. At the end of the recording the last word or group of words has benn replaced by a beep. Select the correct option to complete the recording`
//     },
//     19: { 
//       component: <Highlight {...queProps} />,
//       title: "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different."
//     },
//     20: { 
//       component: <Dictation {...queProps} />,
//       title: "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once."
//     }
//   };

//   return questionComponents[state.type] || { component: null, title: "" };
// }, [state.questionData, state.currentQuestion, state.type, state.stopRecording, state.result.strategy, submitResponse, resultStatus, soundChecked, nextQuestion, setStrategy]);

// // Calculate question numbers - memoized
// const questionNumbers = useMemo(() => ({
//   current: state.currentQuestion + state.curr_q + 1,
//   total: state.questionData.length + state.curr_q
// }), [state.currentQuestion, state.curr_q, state.questionData.length]);

// // Get current question and title
// const { component: que, title } = getQuestionComponent() || { component: null, title: "" };

// // Destructure state for cleaner JSX
// const {
//   questionData,
//   currentQuestion,
//   type,
//   all_ok,
//   timeOutFlag,
//   soundModal,
//   modal,
//   msg,
//   nextType,
//   typeArr,
//   resourceTested,
//   fullArr,
//   timeArr,
//   mockBreak,
//   dashboardFlag,
//   changePhase,
//   secondCount,
//   saveProcess,
//   resultId,
//   submitProcess,
//   waitFlag,
//   testIndex,
//   save_and_exit,
//   mock_already_complete,
//   check_ok,
//   redirect_to_begin,
//   redirect_to_pending,
//   internet,
//   loading
// } = state;

// // Return JSX - Same from line 1 to end of return statement
// return (
//   <>
//     {!mock_already_complete && redirect_to_pending && (
//       <div className="content questionsArea mock-already-completed">
//         <Row>
//           <Col xs={12}>
//             <CardBody>
//               <Row className='testFinish unselectable'>
//                 <div className="col-sm-12">
//                   <p>
//                     <span>
//                       This mock is unfinished. Please{' '}
//                       <Button 
//                         onClick={() => redirectToMock(location.state?.id, 1)} 
//                         color="primary" 
//                         size="xs"
//                       >
//                         Click here
//                       </Button>{' '}
//                       to resume this test.
//                     </span>
//                   </p>
//                 </div>
//               </Row>
//             </CardBody>
//           </Col>
//         </Row>
//       </div>
//     )}

//     {!mock_already_complete && redirect_to_begin && (
//       <div className="content questionsArea mock-already-completed">
//         <Row>
//           <Col xs={12}>
//             <CardBody>
//               <Row className='testFinish unselectable'>
//                 <div className="col-sm-12">
//                   <p>
//                     <span>
//                       You can't resume this mock.{' '}
//                       <Button 
//                         onClick={() => redirectToMock(location.state?.id, 0)} 
//                         color="primary" 
//                         size="xs"
//                       >
//                         Click here
//                       </Button>{' '}
//                       to begin this test.
//                     </span>
//                   </p>
//                 </div>
//               </Row>
//             </CardBody>
//           </Col>
//         </Row>
//       </div>
//     )}

//     {mock_already_complete === true && (
//       <div className="content questionsArea mock-already-completed">
//         <Row>
//           <Col xs={12}>
//             <CardHeader>
//               <Row>
//                 <Col xs={12}>
//                   <CardTitle tag="h4">
//                     {state.title}
//                   </CardTitle>
//                 </Col>
//               </Row>
//             </CardHeader>
//             <CardBody>
//               <Row className='testFinish unselectable'>
//                 <div className="col-sm-12">
//                   <p>
//                     <span>
//                       Dear user, you've already <strong>FINISHED</strong> this mock. 
//                       Please attempt some other mock.
//                     </span>
//                   </p>
//                 </div>
//               </Row>
//             </CardBody>
//           </Col>
//         </Row>
//       </div>
//     )}

//     {!all_ok && <ChromeCheck />}

//     {!mock_already_complete && !redirect_to_pending && check_ok && all_ok && (
//       <>
//         {timeOutFlag && (
//           <Modal isOpen={timeOutFlag} size="sm">
//             <ModalBody>
//               <div>Test stopped due to timeout.</div>
//             </ModalBody>
//             <ModalFooter>
//               <Button color="secondary" className="modalCloseBtn" onClick={closeTimeoutModal}>
//                 OK
//               </Button>
//             </ModalFooter>
//           </Modal>
//         )}

//         {soundModal && (
//           <Modal isOpen={soundModal} size="sm">
//             <ModalBody>
//               <div>Please wait for question audio to be finished.</div>
//             </ModalBody>
//             <ModalFooter>
//               <Button color="secondary" className="modalCloseBtn" onClick={closeSoundModal}>
//                 OK
//               </Button>
//             </ModalFooter>
//           </Modal>
//         )}

//         {modal && (
//           <Modal isOpen={modal} size="sm">
//             <ModalBody>
//               <div>{msg}</div>
//             </ModalBody>
//             <ModalFooter>
//               <Button color="secondary" className="modalCloseBtn" onClick={toggleYes}>
//                 {nextType !== 3 ? "Yes" : "Ok"}
//               </Button>
//               {nextType !== 3 && (
//                 <Button color="secondary" className="modalCloseBtn" onClick={toggle}>
//                   No
//                 </Button>
//               )}
//             </ModalFooter>
//           </Modal>
//         )}

//         {typeArr && !resourceTested && (
//           <ResourceCheck
//             showTest={showTest}
//             pending={location.state?.pending}
//             data={{ type: typeArr, full: fullArr, time: timeArr, break: mockBreak }}
//             cat={5}
//           />
//         )}

//         {!dashboardFlag && !changePhase && resourceTested && (
//           <div className="content questionsArea old-design">
//             <Row>
//               <Col xs={12}>
//                 <Card className="card-wrapper">
//                   <CardHeader>
//                     <Row>
//                       <Col xs={6}>
//                         <CardTitle tag="h4">
//                           {state.title}
//                         </CardTitle>
//                       </Col>
//                       <Col xs={6}>
//                         <div className="text-right questionTime">
//                           <div className="timeRemaining">
//                             <p>
//                               <i className="fa fa-clock-o"></i>{' '}
//                               <span>
//                                 Time Remaining: {Math.floor(secondCount / 60)}:{parseInt(secondCount % 60)}
//                               </span>
//                             </p>
//                           </div>
//                           <div className="item">
//                             <p>Question {questionNumbers.current} of {questionNumbers.total}</p>
//                           </div>
//                         </div>
//                       </Col>
//                     </Row>
//                   </CardHeader>
//                   <CardBody>
//                     {title}
//                     <Row className='unselectable'>
//                       {secondCount === 0 && testIndex < 2 && (
//                         <div>Time up please restart the Test</div>
//                       )}
//                       {internet ? (
//                         secondCount >= 0 && questionData && !loading && que
//                       ) : (
//                         <>
//                           <Skeleton 
//                             count={1} 
//                             width={"50%"} 
//                             height={200} 
//                             containerClassName="skeleton-wrapper__mockrecording" 
//                           />
//                           <Skeleton 
//                             count={5} 
//                             width={"100%"} 
//                             containerClassName="skeleton-wrapper__mocklines" 
//                           />
//                         </>
//                       )}
//                       {secondCount === 0 && testIndex >= 2 && (
//                         <div>Test is now complete.</div>
//                       )}
//                     </Row>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col xs={12}>
//                 <div className="bottomBtns card-wrapper">
//                   <Row>
//                     <Col xs={9}>
//                       {!dashboardFlag && !saveProcess && !resultId && (
//                         <Button color="primary" onClick={(e) => nextButton(e, 2)} size="xs">
//                           Save & Exit
//                         </Button>
//                       )}
//                       {saveProcess && !(questionData.length !== (currentQuestion + 1)) && (
//                         <Button color="primary" size="xs">Wait...</Button>
//                       )}
//                       {submitProcess && !(questionData.length !== (currentQuestion + 1)) && (
//                         <Button color="primary" size="xs">Wait...</Button>
//                       )}
//                       {resultId && (
//                         <NavLink to={`/admin/result/${resultId}`}>
//                           <Button color="primary" size="xs">Show Result</Button>
//                         </NavLink>
//                       )}
//                       {dashboardFlag && (
//                         <NavLink to={'/admin/dashboard'}>
//                           <Button color="primary" size="xs">Go to Dashboard</Button>
//                         </NavLink>
//                       )}
//                       {timeOutFlag && (
//                         <div>Test stopped due to timeout</div>
//                       )}
//                     </Col>
//                     <Col xs={3}>
//                       {!dashboardFlag && secondCount !== 0 && !resultId && 
//                        (questionData.length !== (currentQuestion + 1)) && 
//                        questionData.length !== 0 && (
//                         <Button color="primary" onClick={(e) => nextButton(e, 0)} size="xs">
//                           NEXT
//                         </Button>
//                       )}
//                       {!dashboardFlag && !submitProcess && secondCount !== 0 && !resultId && 
//                        !(questionData.length !== (currentQuestion + 1)) && (
//                         <Button color="primary" onClick={(e) => nextButton(e, 1)} size="xs">
//                           Submit
//                         </Button>
//                       )}
//                     </Col>
//                   </Row>
//                 </div>
//               </Col>
//             </Row>
//           </div>
//         )}

//         {dashboardFlag && (
//           <div className="questionsArea outer-wrapper w-100">
//             <Row>
//               <Col xs={12}>
//                 <Card className="card-wrapper">
//                   <CardHeader>
//                     <Row>
//                       <Col xs={6}>
//                         <CardTitle tag="h4">
//                           {state.title}
//                         </CardTitle>
//                       </Col>
//                     </Row>
//                   </CardHeader>
//                   <CardBody>
//                     <Row className='testFinish unselectable'>
//                       <div className="col-sm-12">
//                         <h4 className="mt-0">
//                           {save_and_exit ? 'Test Pending' : 'Submit Activity'}
//                         </h4>
//                         <p>
//                           {save_and_exit ? (
//                             <span>
//                               This test is not complete. You can resume this test from{' '}
//                               <strong>Pending Test area</strong>.
//                             </span>
//                           ) : (
//                             <span>
//                               The test is now complete. Your report will be available soon in the{' '}
//                               <strong>Tests Finished area</strong>.
//                             </span>
//                           )}
//                         </p>
//                         <NavLink to={'/admin/dashboard'}>
//                           <button className="btn test-continue-btn">Continue</button>
//                         </NavLink>
//                       </div>
//                     </Row>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col xs={12}>
//                 <div className="bottomBtns card-wrapper">
//                   <Row>
//                     <Col xs={12}>
//                       {dashboardFlag && (
//                         <NavLink to={'/admin/dashboard'}>
//                           <Button color="primary" size="xs">Go to Dashboard</Button>
//                         </NavLink>
//                       )}
//                       {timeOutFlag && (
//                         <div>Test stopped due to timeout</div>
//                       )}
//                     </Col>
//                   </Row>
//                 </div>
//               </Col>
//             </Row>
//           </div>
//         )}

//         {changePhase && (typeArr[testIndex] !== 3 || (typeArr[testIndex] === 3 && !waitFlag)) && (
//           <div className="questionsArea outer-wrapper">
//             <Row>
//               <Col xs={12}>
//                 <Card className="card-wrapper">
//                   <CardHeader>
//                     <Row>
//                       <Col xs={6}>
//                         <CardTitle tag="h4">
//                           {state.title}
//                         </CardTitle>
//                       </Col>
//                       <Col xs={6}>
//                         <div className="text-right questionTime"></div>
//                       </Col>
//                     </Row>
//                   </CardHeader>
//                   <CardBody>
//                     <Row className='unselectable'>
//                       <div className="col-lg-12">
//                         <div className="timeRemaining">
//                           <p>
//                             <i className="fa fa-clock-o"></i>
//                             <span>
//                               Time Remaining: {Math.floor(secondCount / 60)}:{parseInt(secondCount % 60)}
//                             </span>
//                           </p>
//                         </div>
//                         <h4 className="mt-0">
//                           Welcome {store.getState().user.first_name} {store.getState().user.last_name}
//                         </h4>
//                         <div className="col-xs-12">
//                           <table className="table table-bordered">
//                             <tbody>
//                               <tr>
//                                 <th>Section</th>
//                                 <th>No of Question</th>
//                                 <th>Time Allowed</th>
//                               </tr>
//                               <tr>
//                                 <td>{getTypeName()}</td>
//                                 <td>{fullArr[testIndex].length}</td>
//                                 <td>{timeArr[testIndex]} minutes</td>
//                               </tr>
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>
//                     </Row>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col xs={12}>
//                 <div className="bottomBtns card-wrapper">
//                   <Row>
//                     <Col xs={9}>
//                       <Button 
//                         color="primary" 
//                         onClick={(e) => nextSection(e)} 
//                         size="xs" 
//                         id="start_next_section"
//                       >
//                         Start Next Section
//                       </Button>
//                     </Col>
//                     <Col xs={3}>
//                       <Button 
//                         color="primary" 
//                         onClick={(e) => exitSection(e)} 
//                         size="xs" 
//                         id="exit_section"
//                       >
//                         Save and Exit
//                       </Button>
//                     </Col>
//                   </Row>
//                 </div>
//               </Col>
//             </Row>
//           </div>
//         )}

//         {changePhase && (typeArr[testIndex] === 3 && waitFlag) && (
//           <div className="questionsArea outer-wrapper">
//             <Row>
//               <Col xs={12}>
//                 <Card className="card-wrapper">
//                   <CardHeader>
//                     <Row>
//                       <Col xs={6}>
//                         <CardTitle tag="h4">
//                           {state.title}
//                         </CardTitle>
//                       </Col>
//                       <Col xs={6}>
//                         <div className="text-right questionTime"></div>
//                       </Col>
//                     </Row>
//                   </CardHeader>
//                   <CardBody>
//                     <Row className='unselectable'>
//                       <div className="col-lg-12">
//                         <div className="timeRemaining">
//                           <p>
//                             <i className="fa fa-clock-o"></i>
//                             <span>
//                               Time Remaining: {Math.floor(secondCount / 60)}:{parseInt(secondCount % 60)}
//                             </span>
//                           </p>
//                         </div>
//                         <h4 className="mt-0">Optional Break</h4>
//                         <h6>
//                           You may now take a break up to 10 minutes. If you want to take a break 
//                           you must leave the testing room.
//                         </h6>
//                         <ol>
//                           <li>
//                             If you want to take a break raise your hand to get the attention 
//                             of the Test Administrator.
//                           </li>
//                           <li>
//                             If you do not want to take a break click on next button below 
//                             to continue the test.
//                           </li>
//                         </ol>
//                         <img src={tenMinutes} alt="10 minutes break" />
//                       </div>
//                     </Row>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col xs={12}>
//                 <div className="bottomBtns card-wrapper">
//                   <Row>
//                     <Col xs={9}>
//                       <Button color="primary" onClick={(e) => skipWait(e)} size="xs">
//                         Skip wait
//                       </Button>
//                     </Col>
//                     <Col xs={3}></Col>
//                   </Row>
//                 </div>
//               </Col>
//             </Row>
//           </div>
//         )}
//       </>
//     )}
//   </>
// );
// }

// export default Test


import React, { memo, useState, useEffect } from "react";
import { useParams , useLocation, useNavigate} from "react-router-dom";
import loadFullMockApi from "components/FullTest/ApiCalls.js";
import ChromeCheck from "components/FullTest/ChromeCheck.jsx";
import ResourceCheck from "components/FullTest/ResourceCheck.jsx";
import Mock from "components/FullTest/Mock.jsx";
import TestResume from "components/FullTest/MockOperations/TestResume";
import TestStart from "components/FullTest/MockOperations/TestStart";
import TestFinished from "components/FullTest/MockOperations/TestFinished";
import LaLoader from "components/Loader/LaLoader";

const NO_SCREEN = 0;

const FullTest = memo(function FullTest(props) {
  console.log("HEre the props of the FullTEst",props)
  const [step, setStep] = useState(NO_SCREEN);
  const [mockData, setMockData] = useState(null);
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    fetchMockDetails();
    // document.body.classList.add("leftSidebarClosed");
    // minimize sidebar.
    document.body.classList.toggle("sidebar-mini");
    
    // prevent context menu.
    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });
  }, []);

  const fetchMockDetails = async () => {
    // const { id, pending, history } = params;
     const id = location.state?.id || params.id;
    const pending = location.state?.pending || params.pending;
    const history = location.state?.history || params.history;
     console.log(id,pending);
    // console.log("id and pending", id, pending);
    // console.log("fetch mock details");
    const res = await loadFullMockApi(id, pending, navigate);
    setMockData(res);
    console.log(res,"We got the data in the FullMock");
    if (parseInt(pending) === 0 && res.resume === true) {
      setStep(4); // resume
    } else if (parseInt(pending) === 1 && !res.resume) {
      setStep(5); // start test
    } else if (res.complete) {
      setStep(6);
    } else {
      if (parseInt(pending) === 1 && step >= 1) {
        setStep(3);
      } else {
        setStep(1);
      }
    }
  };

  const renderElement = () => {
    const { pending } = params;
    console.log(params.id, "mock id");
    let element = "";
    
     if (!mockData) {
      return <LaLoader show={!mockData} />;
    }

    switch (step) {
      case 1:
        element = <ChromeCheck setStep={setStep} />;
        break;
      case 2:
        element = <ResourceCheck setStep={setStep} />;
        break;
      case 3:
        element = (
          <Mock
            setStep={setStep}
            params={params}
            mockData={mockData}
            defaultCheckPoint={parseInt(pending) === 1 ? 2 : 1}
          />
        );
        break;
      case 4:
        element = <TestResume mockId={params.id} />;
        break;
      case 5:
        element = <TestStart mockId={params.id} />;
        break;
      case 6:
        element = <TestFinished />;
        break;
      default:
      // do nothing.
    }

    return element;
  };

  return renderElement();
});

export default FullTest;
